import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';
import type { VehicleFeatures } from 'Pages/vehicles/helpers/vehicle.schema';

export const useVehicleFeaturesSection = (): VehicleFeatures => {
	const { features } = useVehicleData();

	return features;
};
